import styled from 'styled-components';
import colors from '../../../../styles/colors';

type WinState = 'win' | 'loss' | 'nc';

export const BoxSingleMatch = styled.div<{ winState?: WinState }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: start;
    width: calc(33.33% - 10px);
    height: 175px;
    background-color: rgb(40, 40, 40);
    padding: 10px 0;
    border: 3px solid ${props =>
        props.winState === 'win'  ? '#28a745' :
        props.winState === 'loss' ? '#dc3545' :
        props.winState === 'nc'   ? '#ffc107' :
        'white'
    };
`;

export const BoxGenericPosterAvatar = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 70%;
    height: 50%;
    margin-bottom: 10px;

    & img {
        width: 100%;
        height: 60px;
        object-fit: cover;
        object-position: top;
        border: 1px solid white;
    }
`;

export const BoxInfoMatchText = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 50%;
    padding: 5px 10px;
    background-color: rgb(47, 47, 47);
`;


export const BoxNameWrestlerOrTypeMatch = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;

    & h2 {
        font-size: 8px;
        font-weight: 500;
        margin: 0;
        padding: 0;
        text-align: center;
        color: ${colors.bgColorBordeaux};
    }
`;



